import { lazy } from 'react';
import { AliveScope } from 'react-activation';
import { Navigate, createBrowserRouter } from 'react-router';
import { Exception404 } from '@/components/biz/exception';
import { AppLayout } from '@/components/layout';
import LoginPage from '@/pages/login';
import { LogoutPage } from '@/pages/logout';
import RegisterPage from '@/pages/register';
import { ThirdCallback } from '@/pages/third/third-callback';
import { GatewayRedirect } from './gateway-redirect';

const ResetPage = lazy(() => import('../pages/reset/index'));
const RecoveryPage = lazy(() => import('../pages/recovery/index'));
const OpenAppPage = lazy(() => import('../pages/openapp/index'));
const OAuthGrantPage = lazy(() => import('../pages/oauthgrant/index'));

const router = createBrowserRouter(
  [
    { path: '/thirdname/:thirdname', element: <ThirdCallback /> },
    {
      element: (
        <AliveScope>
          <AppLayout />
        </AliveScope>
      ),
      children: [
        { path: '/', element: <Navigate to={{ pathname: '/preLogin', search: window.location.search }} replace /> },
        { index: true, path: '/preLogin', element: <LoginPage /> },
        { path: '/register', element: <RegisterPage /> },
        { path: '/resetPassword', element: <ResetPage /> },
        { path: '/404', element: <Exception404 /> },
        { path: '/gateway', element: <GatewayRedirect /> },
        { path: '/recovery', element: <RecoveryPage /> },
        { path: '/logout', element: <LogoutPage /> },
        { path: '/openapp', element: <OpenAppPage /> },
        { path: '/oauthgrant', element: <OAuthGrantPage /> },
        { path: '*', element: <Navigate to={{ pathname: '/404', search: window.location.search }} /> },
      ],
    },
  ],
  {
    basename: import.meta.env.VITE_PUBLIC_PATH || '/',
  },
);

export default router;
